export default "__VITE_ASSET__ClPKgPDT__"